var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1678_67)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6984 1.25867C7.1899 0.113808 8.81019 0.113808 9.30169 1.25867L10.7892 4.72358C10.821 4.79776 10.8901 4.84743 10.9683 4.8547L14.7131 5.2031C15.9537 5.31852 16.4487 6.86198 15.5179 7.68228L12.6924 10.1721C12.6325 10.2249 12.6056 10.307 12.6234 10.3862L13.4503 14.0665C13.7222 15.2769 12.4171 16.2375 11.3438 15.5983L8.11009 13.6722C8.04217 13.6317 7.95792 13.6317 7.89 13.6722L4.65628 15.5983C3.58303 16.2375 2.27785 15.2769 2.54982 14.0665L3.3767 10.3862C3.3945 10.307 3.36754 10.2249 3.30765 10.1721L0.482222 7.68228C-0.448633 6.86198 0.0464156 5.31852 1.28704 5.2031L5.03179 4.8547C5.10996 4.84743 5.17905 4.79776 5.21089 4.72358L6.6984 1.25867Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid);
export default __webpack_public_path__ + "static/media/star-solid.513e6d68c791116d0706df1ff322a4ad.svg";
export { ForwardRef as ReactComponent };